import React from 'react'
import PropTypes from 'prop-types'

// Outline info-circle (circle + i) — FA Free only ships `fa-info-circle` as solid.
const PATH_D = 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z M12 12v4 M12 8h.01'

const InfoCircleOutlineIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d={PATH_D}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

InfoCircleOutlineIcon.propTypes = {
  className: PropTypes.string
}

InfoCircleOutlineIcon.defaultProps = {
  className: 'tw:h-3.5 tw:w-3.5'
}

export default InfoCircleOutlineIcon
